import { getMetadataEntityValueHelper } from '@components/table/TableCreateFiltersModal/getMetadataEntityValueHelper';
import { TableFilter } from '@components/table/types';
import { EntityMetadataGetRequestQuery } from '@lio/api-types';

export const policyTableFilterMetadataBuilder: Record<
  TableFilter,
  {
    appliedFilterKey: string;
    metaDataQueryKey: keyof EntityMetadataGetRequestQuery;
    getQueryValue: ReturnType<typeof getMetadataEntityValueHelper>;
  } | null
> = {
  [TableFilter.OFFERING_TYPEAHEAD]: {
    appliedFilterKey: 'product',
    metaDataQueryKey: 'offering.id',
    getQueryValue: getMetadataEntityValueHelper('product'),
  },
  [TableFilter.BUSINESS_CLASS_TYPEAHEAD]: {
    appliedFilterKey: 'productOption',
    metaDataQueryKey: 'productOption.id',
    getQueryValue: getMetadataEntityValueHelper('productOption'),
  },
  [TableFilter.PRODUCT_LABEL_TYPEAHEAD]: {
    appliedFilterKey: 'productLabel',
    metaDataQueryKey: 'productLabel.id',
    getQueryValue: getMetadataEntityValueHelper('productLabel'),
  },
  [TableFilter.WRITING_COMPANY_TYPEAHEAD]: {
    appliedFilterKey: 'writingCompany',
    metaDataQueryKey: 'writingCompany.id',
    getQueryValue: getMetadataEntityValueHelper('writingCompany'),
  },
  [TableFilter.UNDERWRITER_TYPEAHEAD_FILTER]: {
    appliedFilterKey: 'underwriter',
    metaDataQueryKey: 'underwriter.id',
    getQueryValue: getMetadataEntityValueHelper('underwriter'),
  },
  [TableFilter.BROKERAGE_TYPEAHEAD]: {
    appliedFilterKey: 'brokerage',
    metaDataQueryKey: 'brokerage.id',
    getQueryValue: getMetadataEntityValueHelper('brokerage'),
  },
  [TableFilter.BROKERAGE_PRODUCER_TYPEAHEAD]: {
    appliedFilterKey: 'producer',
    metaDataQueryKey: 'brokerageProducer.id',
    getQueryValue: getMetadataEntityValueHelper('producer'),
  },
  [TableFilter.JURISDICTION_TYPEAHEAD]: null,
  [TableFilter.CHECKBOX]: null,
  [TableFilter.NUMBER_RANGE]: null,
  [TableFilter.SEARCH]: null,
  [TableFilter.SELECT_SINGLE]: null,
  [TableFilter.DATE]: null,
  [TableFilter.DATE_RANGE]: null,
  [TableFilter.DATE_TIME]: null,
  [TableFilter.CHIP_GROUP]: null,
  [TableFilter.TEXT_FIELD]: null,
  [TableFilter.TRANSACTION_TYPE_TYPEAHEAD]: null,
  [TableFilter.QUOTE_STATUS_TYPEAHEAD]: null,
  [TableFilter.POLICY_STATUS_FILTER]: null,
  [TableFilter.INSURANCE_LINE_TYPEAHEAD]: null,
  [TableFilter.LINE_OF_BUSINESS_TYPEAHEAD]: null,
  [TableFilter.COVERAGE_CATEGORY_TYPEAHEAD]: null,
  [TableFilter.QUOTE_ORIGIN_TYPEAHEAD]: null,
  [TableFilter.REPORTING_QUOTE_SOURCE_TYPEAHEAD]: null,
  [TableFilter.UNDERWRITING_ACTIVITY_TYPE_TYPEAHEAD]: null,
  [TableFilter.POST_RATE_DEFAULT_FACTOR_TYPEAHEAD]: null,
  [TableFilter.BROKERAGE_DIVISION_TYPEAHEAD]: null,
};
